/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkNotificationAsRead200Response
 */
export interface MarkNotificationAsRead200Response {
    /**
     * 
     * @type {boolean}
     * @memberof MarkNotificationAsRead200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the MarkNotificationAsRead200Response interface.
 */
export function instanceOfMarkNotificationAsRead200Response(value: object): value is MarkNotificationAsRead200Response {
    return true;
}

export function MarkNotificationAsRead200ResponseFromJSON(json: any): MarkNotificationAsRead200Response {
    return MarkNotificationAsRead200ResponseFromJSONTyped(json, false);
}

export function MarkNotificationAsRead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkNotificationAsRead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function MarkNotificationAsRead200ResponseToJSON(json: any): MarkNotificationAsRead200Response {
    return MarkNotificationAsRead200ResponseToJSONTyped(json, false);
}

export function MarkNotificationAsRead200ResponseToJSONTyped(value?: MarkNotificationAsRead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

